const $inject = ['moment'];

const dateFilter = (moment) => (value) => {
    if(!value) return value;
    return moment(value).format('M/D/YYYY h:mm A');
};

dateFilter.$inject = $inject;

export default dateFilter;



// WEBPACK FOOTER //
// ./src/filters/dateFilter.js